/* eslint-disable no-unused-vars */
import { useCallback, useEffect, useRef, useState } from 'react';
import { Buttons, Each, FloatingPopUp } from 'components';
import { useParams } from 'react-router-dom';
import {
  BulkDirectBuyIcon,
  BulkIncludeIcon,
  BulkExcludeIcon,
  BulkUpdateBidIcon,
  BulkResetCustomBidIcon,
  PauseAction,
  StartIcon,
} from 'assets/icons';
import { campaignReportsActions } from 'store/actions';
import { campaignReportsAPI } from 'services/campaignReports.service';
import * as S from './BulkActionPanel.styled';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import store from 'store';
import { showPolipop, getDynamicUrl } from 'utils';
import { UpdateBidPopUp } from '../../updateBidPopUp/UpdateBidPopUp';
import { isAdminSelector } from 'store/selectors';
import { routes } from 'config';

const myState = store.getState();
const dispatch = store.dispatch;

const eventListenerAction = (isOpen, closeOnClickOutside) => {
  const method = isOpen ? 'addEventListener' : 'removeEventListener';
  const options = { capture: true };
  window[method]('wheel', closeOnClickOutside, isOpen ? { ...options, once: true } : options);
  window[method]('click', closeOnClickOutside, options);
};

const btnTypesArrayForApps = [
  {
    title: 'Direct Buy',
    id: 'direct_buy',
    onClickAction: ({ selectedTableItems, cmp_id, navigate }) => {
      console.log({ selectedTableItems, cmp_id });
      const bid = selectedTableItems[0].cpi;
      const pba_numbers = selectedTableItems.map(({ pba_number }) => pba_number);
      let url = getDynamicUrl(
        routes.list.find((route) => route.id === 'campaign/directCampaign').url,
        {
          cmp_id,
        },
      );
      url = `${url}?app=${pba_numbers}&bid=${bid}`;
      navigate(url);
    },
    icon: BulkDirectBuyIcon,
    isDisabled: (params) => {
      return !params.length;
    },
  },
  {
    title: 'Include',
    id: 'include',
    onClickAction: async ({ bulkUpdateCampainAppAction, selectedTableItems, cmp_id }) => {
      const obj = {
        act: 'add',
        apps: selectedTableItems.map(({ pba_number }) => pba_number).join(','),
        cm_id: cmp_id,
      };
      const result = await bulkUpdateCampainAppAction(obj);
      console.log({ result });
    },
    icon: BulkIncludeIcon,
    isDisabled: (params) => {
      const appStatusSet = new Set(params.map(({ appStatus }) => appStatus));
      const result = !(appStatusSet.size > 0 && appStatusSet.has('excluded'));
      return result;
    },
  },
  {
    title: 'Exclude',
    id: 'exclude',
    onClickAction: async ({ bulkUpdateCampainAppAction, selectedTableItems, cmp_id }) => {
      const obj = {
        act: 'del',
        apps: selectedTableItems.map(({ pba_number }) => pba_number).join(','),
        cm_id: cmp_id,
      };
      const result = await bulkUpdateCampainAppAction(obj);
      console.log({ result });
    },
    icon: BulkExcludeIcon,
    isDisabled: (params) => {
      const appStatusSet = new Set(params.map(({ appStatus }) => appStatus));
      const result = !(appStatusSet.size > 0 && appStatusSet.has('included'));
      return result;
    },
  },
  {
    title: 'Update Bid',
    id: 'update_bid',
    onClickAction: ({ openCloseAction }) => {
      openCloseAction();
    },
    icon: BulkUpdateBidIcon,
    isDisabled: (params) => {
      return !params.length;
    },
  },
  {
    title: 'Reset Custom Bid',
    id: 'reset_custom_bid',
    onClickAction: async ({ resetCustomCpiBulkAction, selectedTableItems, cmp_id }) => {
      const obj = {
        pbaNumbers: selectedTableItems.map(({ pba_number }) => pba_number).join(','),
        cm_id: cmp_id,
      };

      const result = await resetCustomCpiBulkAction(obj);
      dispatch(campaignReportsActions.clearUpdatedBids());
      console.log({ result });
    },
    icon: BulkResetCustomBidIcon,
    isDisabled: (params, updatedBids) => {
      const appStatusSet = new Set(params.map(({ isCustomCpi }) => isCustomCpi));

      return !(appStatusSet.size > 0 && (appStatusSet.has(1) || !!updatedBids?.length));
    },
  },
  {
    title: 'Cancel Bulk Actions',
    id: 'cancel_bulk_actions',
    onClickAction: ({ id }) => {
      dispatch(
        campaignReportsActions.updateProperty({
          propField: 'isPressedBulkBtn',
          newValue: false,
        }),
      );
      dispatch(
        campaignReportsActions.updateProperty({
          propField: 'selectedTableItems',
          newValue: [],
        }),
      );
    },
    isDisabled: () => {
      return false;
    },
  },
];

const btnTypesArrayForCreative = [
  {
    title: 'Exclude',
    id: 'excludeCreative',
    onClickAction: async ({ bulkActionsEnableDisableCreative, selectedTableItems, cmp_id }) => {
      const payload = {
        bn_ids: selectedTableItems.map(({ bn_bannerId }) => bn_bannerId).join(','),
        cm_id: cmp_id,
        newBnStatus: 1,
      };
      const result = await bulkActionsEnableDisableCreative(payload);
      console.log({ result });
    },
    icon: PauseAction,
    isDisabled: (params) => {
      const appStatusSet = new Set(params.map(({ bn_status }) => bn_status));
      const result = !(appStatusSet.size > 0 && appStatusSet.has(0));
      return result;
    },
  },
  {
    title: 'Include',
    id: 'includeCreative',
    onClickAction: async ({ bulkActionsEnableDisableCreative, selectedTableItems, cmp_id }) => {
      const payload = {
        bn_ids: selectedTableItems.map(({ bn_bannerId }) => bn_bannerId).join(','),
        cm_id: cmp_id,
        newBnStatus: 0,
      };
      const result = await bulkActionsEnableDisableCreative(payload);
      console.log({ result });
    },
    icon: StartIcon,
    isDisabled: (params) => {
      const appStatusSet = new Set(params.map(({ bn_status }) => bn_status));
      const result = !(appStatusSet.size > 0 && appStatusSet.has(1));
      return result;
    },
  },
  {
    title: 'Cancel Bulk Actions',
    id: 'cancel_bulk_actions',
    onClickAction: ({ id }) => {
      dispatch(
        campaignReportsActions.updateProperty({
          propField: 'isPressedBulkBtn',
          newValue: false,
        }),
      );
      dispatch(
        campaignReportsActions.updateProperty({
          propField: 'selectedTableItems',
          newValue: [],
        }),
      );
    },
    isDisabled: () => {
      return false;
    },
  },
];

const chooseBtn = {
  Apps: btnTypesArrayForApps,
  Creative: btnTypesArrayForCreative,
};

const successAction = () => {
  dispatch(
    campaignReportsActions.updateProperty({
      propField: 'selectedTableItems',
      newValue: [],
    }),
  );
};

export const BulkActionsPanel = ({ isAdmin }) => {
  const currentRequestType = useRef(null);

  const [bulkActionsEnableDisableCreative, resultBulkActionsEnableDisableCreative] =
    campaignReportsAPI.useBulkActionsEnableDisableCreativeMutation();

  const [bulkUpdateCampainAppAction, bulkUpdateCampainAppResult] =
    campaignReportsAPI.useBulkUpdateCampainAppTargetingMutation();

  const [resetCustomCpiBulkAction, resetResult] =
    campaignReportsAPI.useResetCustomCpiBulkMutation();

  const [changeBidAction, changeBidResult] =
    campaignReportsAPI.useIncreaseDecreaseBidBulkMutation();

  const handleBidChange = async (newBid) => {
    const obj = {
      cpi: newBid,
      pbaNumbers: selectedTableItems.map(({ pba_number }) => pba_number).join(','),
      cm_id: cmp_id,
    };
    const updatedBids = selectedTableItems.map(({ pba_number }) => {
      return { id: pba_number, bid: newBid };
    });
    dispatch(campaignReportsActions.addUpdatedBids(updatedBids));
    const result = await changeBidAction(obj);
    console.log({ result });
  };

  const isPressedBulkBtn = useSelector((state) => state.campaignReports.isPressedBulkBtn);
  const tableRequestTypes = useSelector((state) => state.campaignReports.tableRequestTypes);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { cmp_id } = useParams();

  const selectedTableItems = useSelector((state) => state?.campaignReports.selectedTableItems);
  const updatedBids = useSelector((state) => state.campaignReports.updatedBidsArray);

  const { data: appData, isLoading: isAppDataLoading } = campaignReportsAPI.useGetCampaignDataQuery(
    {
      cm_id: cmp_id,
    },
  );
  const isCpm = appData?.bid_type === 1;
  const minBid = isCpm
    ? window.cpm_bid_minimum
    : isAdmin
    ? window.bid_minimum_admin
    : appData?.min_bid;
  const maxBid = isCpm ? window.cpm_bid_maximum : window.bid_maximum;

  useEffect(() => {
    if (
      currentRequestType.current === 'update_bid' &&
      changeBidResult &&
      (changeBidResult.isError || changeBidResult.isSuccess)
    ) {
      showPolipop(changeBidResult, successAction);
      return;
    }
    if (
      (currentRequestType.current === 'exclude' || currentRequestType.current === 'include') &&
      bulkUpdateCampainAppResult &&
      (bulkUpdateCampainAppResult.isError || bulkUpdateCampainAppResult.isSuccess)
    ) {
      showPolipop(bulkUpdateCampainAppResult, successAction);
      return;
    }
    if (
      currentRequestType.current === 'reset_custom_bid' &&
      resetResult &&
      (resetResult.isError || resetResult.isSuccess)
    ) {
      showPolipop(resetResult, successAction);
      return;
    }
    if (
      (currentRequestType.current === 'excludeCreative' ||
        currentRequestType.current === 'includeCreative') &&
      resultBulkActionsEnableDisableCreative &&
      (resultBulkActionsEnableDisableCreative.isError ||
        resultBulkActionsEnableDisableCreative.isSuccess)
    ) {
      showPolipop(resultBulkActionsEnableDisableCreative, successAction);
      return;
    }
  }, [
    bulkUpdateCampainAppResult,
    resetResult,
    currentRequestType.current,
    changeBidResult,
    resultBulkActionsEnableDisableCreative,
  ]);

  if (!isPressedBulkBtn) return null;

  return (
    <S.BulkBox isActive={isPressedBulkBtn}>
      <Each
        fieldOfIndex='id'
        of={chooseBtn[tableRequestTypes]}
        render={(item, index) => {
          const { icon: Icon, id, isDisabled } = item;
          const [isOpen, setIsOpen] = useState(false);

          const openCloseAction = () => {
            let newIsOpen = !isOpen;
            setIsOpen(newIsOpen);
            eventListenerAction(newIsOpen, closeOnClickOutside);
          };

          const closeOnClickOutside = useCallback((event) => {
            const { type, target } = event;
            const shouldClose =
              type === 'wheel' || (type === 'click' && !target.closest('.update_bid_popup'));
            if (shouldClose) {
              setIsOpen(false);
              window.removeEventListener('wheel', closeOnClickOutside, true);
              window.removeEventListener('click', closeOnClickOutside, true);
              event.stopPropagation();
            }
          }, []);
          return (
            <S.Box
              isLastBtn={id === 'cancel_bulk_actions'}
              className={id === 'update_bid' && `update_bid_popup`}
            >
              <FloatingPopUp
                durationValue={30}
                isArrow
                offsetValue={12}
                triggerStyle={{ zIndex: isOpen && 2100 }}
                defaultPlacement={FloatingPopUp.placements.top}
                isOpen={isOpen}
                isOverlay={false}
                popUpComponent={
                  <UpdateBidPopUp
                    onSetBid={handleBidChange}
                    minBid={minBid}
                    maxBid={maxBid}
                    isCpm={isCpm}
                    isBulcActions={true}
                    isAppDataLoading={isAppDataLoading}
                    onClose={openCloseAction}
                    pba_number={selectedTableItems.map(({ pba_number }) => pba_number).join(',')}
                    location='bulkActions'
                    // isAdmin={isAdmin}
                  />
                }
                triggerComponent={
                  <Buttons.TertiarySmall
                    id={item.id}
                    icon={Icon ? <Icon /> : null}
                    isPressed={isOpen}
                    isDisabled={isDisabled(selectedTableItems, updatedBids)}
                    onClick={() => {
                      currentRequestType.current = id;
                      item.onClickAction({
                        bulkActionsEnableDisableCreative,
                        bulkUpdateCampainAppAction,
                        selectedTableItems,
                        cmp_id,
                        resetCustomCpiBulkAction,
                        openCloseAction,
                        navigate,
                      });
                    }}
                  >
                    {item.title}
                  </Buttons.TertiarySmall>
                }
              />
            </S.Box>
          );
        }}
      />
    </S.BulkBox>
  );
};
